import React from 'react';
import { Wysiwyg } from '../../Wysiwyg';
import { WysiwygModifier } from '../../Wysiwyg/Wysiwyg';
import { PostReply } from '../Post.types';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum PostBubbleModifier {
  ROUND = 'round',
  SMALL_MARGIN_BOTTOM = 'small-margin-bottom',
}

export function PostBubble({
  model,
  modifier,
  smallText,
  verySmallPadding,
}: {
  model: PostReply;
  modifier?: Modifier<PostBubbleModifier>;
  smallText?: boolean;
  verySmallPadding?: boolean;
}) {
  const getWysiwygModifier = () => {
    const wysiwygModifier = [WysiwygModifier.SMALL_PADDING]; // default
    if (smallText) {
      wysiwygModifier.push(WysiwygModifier.SMALL_TEXT);
    }
    if (verySmallPadding) {
      wysiwygModifier.push(WysiwygModifier.VERY_SMALL_PADDING);
    }
    return wysiwygModifier;
  };
  return (
    <div className={bem('posts__bubble', modifier)}>
      <Wysiwyg
        content={model.content}
        modifier={getWysiwygModifier()}
        resourceReferencesToToUrls={model.resourceReferencesToToUrls}
      />
    </div>
  );
}
